/**
 * The pricing endpoint behind the composition editor's market date (MDOT-25191), and the only
 * place in the tree that calls `priceInstruments` — deleting `market-date/` takes the call site
 * with it. When the composition belongs to no portfolio, `./reprice` prices it another way.
 */
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { axiosExtract } from "$root/third-party-integrations/axios";
import {
	type InstrumentPricing,
	InvestmentSharesControllerV4ApiFactory,
	type SharesPricingRequest,
} from "@eu.mdotm.api/sphere";

const { newAction } = repositoryHelperFactory("marketDatePricing");

const sharesApi = () => getApiGen(InvestmentSharesControllerV4ApiFactory);

export const marketDatePricingRepository = {
	/**
	 * Prices `request.identifiers` for the portfolio at `request.referenceDate` and says how each is
	 * held. Synchronous server-side; the day must fall in the portfolio's edit window, which is the
	 * window the editor's date control already offers.
	 */
	priceInstruments: newAction(
		async (investmentUuid: string, request: SharesPricingRequest): Promise<InstrumentPricing[]> =>
			(await axiosExtract(sharesApi().priceInstruments(investmentUuid, request))).instruments ?? [],
	),
} as const;
